export default "__VITE_ASSET__87a14872__"